import React from 'react'

const SpinIndicator = () => <div className="spin-indicator">&nbsp;</div>

export default React.memo(SpinIndicator)
